// extracted by mini-css-extract-plugin
export default {"leaveSpace":"leave-space_leaveSpace__pfCto"};